export const ORGANIZATION_TYPES = [
  { label: 'Bank', value: 'bank' },
  { label: 'Credit union', value: 'credit_union' },
  { label: 'IMB', value: 'imb' },
  { label: 'Broker/Wholesale', value: 'broker_wholesale' },
];
export const RATE_TYPES = ['adjustable', 'variable', 'fixed', 'balloon'];

export const DEBOUNCE_DELAY = 500;

export const CONSUMER_DIRECT_TYPES = [
  { label: 'Yes', value: 'include' },
  { label: 'No', value: 'exclude' },
];
